import React from "react";
import "./WatchAppointmentVideo.css";

const WatchAppointmentVideo = () => {
    return (
        <div className="appointment-video-page">
            <div className="container py-5">

                {/* Header */}
                <div className="text-center mb-4">

                    <span className="appointment-badge">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="me-2"
                            viewBox="0 0 16 16"
                        >
                            <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                        </svg>

                        Online Appointment
                    </span>

                    <h1 className="appointment-title mt-3">
                        How to Book an Online Appointment
                    </h1>

                    <p className="appointment-subtitle">
                        Watch this short video to learn how to book your
                        appointment online quickly and easily.
                    </p>
                </div>

                {/* Video Card */}
                <div className="video-wrapper">

                    <div className="video-header">
                        <div>

                            <h5 className="mb-1 d-flex align-items-center gap-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                                </svg>

                                Online Appointment Guide
                            </h5>

                            <small>
                                Watch the video and follow the instructions
                            </small>

                        </div>
                    </div>

                    {/* YouTube Video */}
                    <div className="video-container">
                        <iframe
                            src="https://www.youtube.com/embed/BpAS2Nvkzx8"
                            title="How to Book an Online Appointment"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen>
                        </iframe>
                    </div>

                </div>

                {/* Information */}
                <div className="appointment-info mt-4">

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="info-icon"
                        viewBox="0 0 16 16"
                    >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                    </svg>

                    <div>
                        <h6>Need help booking your appointment?</h6>

                        <p className="mb-0">
                            Please watch the complete video carefully and
                            follow the step-by-step instructions to book
                            your online appointment.
                        </p>
                    </div>

                </div>

            </div>
        </div>
    );
};

export default WatchAppointmentVideo;